"use strict";

export default {
  namespaced: true,

  state: {
    currentTeam: null,
    currentTeamOpenings: null
  },

  mutations: {
    setCurrentTeam(state, payload) {
      state.currentTeam = payload;
    },

    setCurrentTeamOpenings(state, payload) {
      state.currentTeamOpenings = payload;
    }
  },

  actions: {
    currentTeam({ commit }, payload) {
      commit("setCurrentTeam", payload);
    },

    currentTeamOpenings({ commit }) {
      const currentTeam = this.getters["teams/currentTeam"],
        allOpeningsByTeam = this.getters["openings/allOpeningsByTeam"];

      let currentTeamOpenings = {};

      for (const teamObject of allOpeningsByTeam) {
        if (teamObject.team === currentTeam) {
          currentTeamOpenings = teamObject.openings;

          break;
        }
      }

      commit("setCurrentTeamOpenings", currentTeamOpenings);
    }
  },

  getters: {
    currentTeam(state) {
      return state.currentTeam;
    },

    currentTeamOpenings(state) {
      return state.currentTeamOpenings;
    }
  }
};
